import { Player } from "types/player";
import { reactive, toRefs } from "vue"

const useAutoComplete = (options: Player[], key: string) => {
    // Declare AutoComplete State
    const state = reactive({
        userInput: "",
        tags: [] as Player[],
        filteredSuggestions: [] as Player[],
        suggestions: options,
        selectedItem: {}
    });

    // Handle Select suggestion
    const selected = (item: Player) => {
        state.userInput = '';
        state.filteredSuggestions = [];
        state.tags.push(item)
    };

    // Handle on tag remove
    const onRemoveTag = (index: number) => {
        state.tags.splice(index, 1);
    }

    // Handle remove last tag (Backspace)
    const removeLastTag = (event: { target: { value: string } }) => {
        if (event.target.value.length === 0) {
            onRemoveTag(state.tags.length - 1)
        }
    }

    // Handle on Input change
    const onChange = () => {
        const input = state.userInput;
        state.selectedItem = { userInput: state.userInput, item: null };
        if (input.length === 0) {
            state.filteredSuggestions = [];
            return;
        }
        const r = state.suggestions.filter(
            (suggestion: Player) => {
                return suggestion[key].toLowerCase().indexOf(input.toLowerCase()) > -1
            }
        );
        state.filteredSuggestions = r;
    };

    // Expose state and fns
    return {
        ...toRefs(state),
        onRemoveTag,
        removeLastTag,
        selected,
        onChange
    };
};

export default useAutoComplete;